import config from '../../config';
import { getAuthHeaders, handleResponse } from './common';

const BASE = `${config.api.url}/lending-library`;

const ACTIVE_CLIENT_STATUS_VALUES = new Set([
  'activeprenatalcare',
  'activepostpartumcare',
  'activewellwomancare',
]);

const isActiveClient = (client) => {
  const status = String(client.clientStatus || client.status || '').toLowerCase();
  if (status) return ACTIVE_CLIENT_STATUS_VALUES.has(status);
  if (client.isActive !== undefined && client.isActive !== null) return client.isActive === true;
  if (client.active !== undefined && client.active !== null) return client.active === true;
  return true;
};

const withQuery = (path, params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') query.set(key, value);
  });
  const suffix = query.toString();
  return `${BASE}${path}${suffix ? `?${suffix}` : ''}`;
};

const request = async (path, options = {}) => {
  const response = await fetch(`${BASE}${path}`, {
    ...options,
    headers: getAuthHeaders(options.headers),
  });
  return handleResponse(response);
};

const lendingLibraryApi = {
  getClientsForCheckout: (staffReferenceId) => fetch(`${config.api.url}/midwives/${staffReferenceId}/clients`, { headers: getAuthHeaders() })
    .then(handleResponse)
    .then((clients) => (Array.isArray(clients) ? clients.filter(isActiveClient) : clients)),
  getItems: (filters = {}) => fetch(withQuery('/items', filters), { headers: getAuthHeaders() }).then(handleResponse),
  createItem: (item) => request('/items', { method: 'POST', body: JSON.stringify(item) }),
  updateItem: (referenceId, item) => request(`/items/${referenceId}`, { method: 'PUT', body: JSON.stringify(item) }),
  removeItem: (referenceId) => request(`/items/${referenceId}`, { method: 'DELETE' }),

  getLoans: (filters = {}) => fetch(withQuery('/loans', filters), { headers: getAuthHeaders() }).then(handleResponse),
  checkout: (loan) => request('/loans', { method: 'POST', body: JSON.stringify(loan) }),
  updateLoan: (referenceId, loan) => request(`/loans/${referenceId}`, { method: 'PUT', body: JSON.stringify(loan) }),
  returnLoan: (referenceId, data) => request(`/loans/${referenceId}/return`, { method: 'POST', body: JSON.stringify(data) }),
  getMyLoans: (status = 'all') => fetch(withQuery('/my-loans', { status }), { headers: getAuthHeaders() }).then(handleResponse),
};

export const lendingLibraryQueryKeys = {
  all: ['lending-library'],
  items: (filters = {}) => ['lending-library', 'items', filters],
  loans: (filters = {}) => ['lending-library', 'loans', filters],
  myLoans: (status = 'all') => ['lending-library', 'my-loans', status],
};

export const LENDING_LIBRARY_CONDITIONS = ['New', 'Good', 'Fair', 'Poor', 'Needs Repair'];

export default lendingLibraryApi;
